export type PrizmStringifyFunc<T> = (a: T | null) => string;
